/* src/app/views/dashboard/components/sidebar-nav/nav-sub-item/nav-sub-item.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.sub-nav-item {
  font-size: 0.75rem;
  list-style: none;
  padding: 0.5rem 0 0.5rem 0.5rem;
  color: #374151;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sub-nav-item:hover {
  color: #222222;
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.sub-nav-item.sub-active {
  color: #222222;
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.alert-indicator {
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 50%;
  background-color: #fa5555;
  margin-right: 0.25rem;
}
/*# sourceMappingURL=nav-sub-item.component.css.map */
